import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const SettingsIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 16"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M0.75 4.16667H12.3864M5.11364 12.8333V10.6667H0.75V15H5.11364V12.8333ZM5.11364 12.8333H16.75M12.3864 2H16.75V6.33333H12.3864V2Z" stroke={color} strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
  </Svg>
);

SettingsIcon.displayName = 'SettingsIcon';
